import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 0
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    marginBottom: theme.spacing(2)
  },
  subTitle: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.grey[600],
    marginTop: 2
  },
  filters: {
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2)
  },
  filterFields: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'minmax(0, 1fr)'
    }
  },
  filterActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2)
  },
  appliedFilters: {
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2)
  },
  tableWrapper: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 6,
    overflowX: 'auto',
    outline: 'none'
  },
  // Free text from adotel or a person: kept in its own direction and line breaks, and
  // capped so a long note cannot push the table off a small screen.
  freeText: {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
    maxWidth: 320,
    [theme.breakpoints.down('sm')]: { maxWidth: 200 }
  },
  reasonAction: {
    display: 'block',
    color: theme.palette.grey[600],
    maxWidth: 240
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 240,
    color: theme.palette.text.secondary
  },
  emptyImage: {
    width: 120,
    maxWidth: '100%',
    marginBottom: theme.spacing(1)
  },
  emptyText: { fontSize: 14 },
  loadingContainer: {
    display: 'flex',
    width: '100%',
    height: 240,
    justifyContent: 'center',
    alignItems: 'center'
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    marginTop: 12,
    paddingTop: 8,
    paddingBottom: 8,
    borderRadius: 12
  },
  summary: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: theme.spacing(2),
    rowGap: theme.spacing(0.5),
    marginBottom: theme.spacing(2)
  },
  summaryLabel: { color: theme.palette.grey[600] }
}))

export default useStyles
